import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceContent from './components/ServiceContent';

const ServicePage = () => {
  usePageMeta({
    title: '事業内容 | 株式会社MSK',
    ogTitle: '事業内容 | 株式会社MSK',
    description: '株式会社MSKの事業内容をご紹介いたします。システムエンジニアリングサービス・受託開発など幅広いITサービスを提供しています。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <ServiceHero />
        <ServiceContent />
      </main>
      <Footer />
    </div>
  );
};

export default ServicePage;